import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
import { Input, Grid, Button } from '../../components';
import { tipoEntidade } from '../../utils/listsSelect';
import { trataMensagensErro } from '../../utils/requests';
import { pad } from '../../utils/helpers';

class FiltroEnteGlosa extends Component {
  constructor() {
    super();
    this.filtroEnteFederativo = JSON.parse(sessionStorage.getItem('filtroEnteFederativo'));

    this.state = {
      'destinatario-rpps':
                this.filtroEnteFederativo && this.filtroEnteFederativo['destinatario-rpps'] ? this.filtroEnteFederativo['destinatario-rpps'] : null,
      cliqueiNoBotao:
                this.filtroEnteFederativo && this.filtroEnteFederativo.cliqueiNoBotao ?
                  this.filtroEnteFederativo.cliqueiNoBotao : null,
      tipoEntidade:
                this.filtroEnteFederativo && this.filtroEnteFederativo.tipoEntidade ?
                  this.filtroEnteFederativo.tipoEntidade : null,
      uf:
                this.filtroEnteFederativo && this.filtroEnteFederativo.uf ?
                  this.filtroEnteFederativo.uf : null,
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem('filtroEnteFederativo')) {
      this.handleSearchButton();
    }
  }

  componentDidUpdate(prevProps) {
    // Apenas repete consulta se parametro da url for alterado
    if (this.props.tipoConsulta !== prevProps.tipoConsulta) {
      this.preparaNovaConsulta();
    }
  }

    controleFiltrosAlternativos = (campo) => {
      switch (campo) {
        case 'destinatario-rpps':
          return ['requerer-compensacao-rgps', 'gerenciar-negocio-dcomp'];
        default:
          return [];
      }
    }

    preparaNovaConsulta = () => {
      let filtroEnteFederativo = {
        'destinatario-rpps': null,
        tipoEntidade: null,
        uf: null,
      };

      filtroEnteFederativo = JSON.stringify(filtroEnteFederativo);
      sessionStorage.setItem('filtroEnteFederativo', filtroEnteFederativo);

      this.setState({
        'destinatario-rpps': null,
        tipoEntidade: null,
        uf: null,
      });
    }

    handleChange = (changeObj, name) => {
      this.setState({
        [name]: changeObj.value,
      }, () => this.trataFormulario(name));
    }

    /**
     * Encaminha para as funcoes que tratam alteracoes em cada campo
     */
    trataFormulario = (campoAlterado) => {
      if (campoAlterado === 'tipoEntidade') {
        this.trataTipoEntidade();
      }
      if (campoAlterado === 'uf') {
        this.trataUf();
      }
    }

    trataUf = () => {
      this.setState({ 'destinatario-rpps': null });
    }

    trataCombosEntidade = () => {
      this.setState({ tipoEntidade: null, 'destinatario-rpps': null, uf: null });
    }

    trataTipoEntidade = () => {
      this.setState({ 'destinatario-rpps': null, uf: null });
    }

    handleSearchButton = () => {
      let filtroEnteFederativo = {
        'destinatario-rpps': this.state['destinatario-rpps'],
        tipoEntidade: this.state.tipoEntidade,
        uf: this.state.uf,

      };
      filtroEnteFederativo = JSON.stringify(filtroEnteFederativo);
      sessionStorage.setItem('filtroEnteFederativo', filtroEnteFederativo);
      this.setState(
        {
          cliqueiNoBotao: 1,
        },
        () => {
          this.handleChange({
            value: 1,
            isValid: true,
          }, 'cliqueiNoBotao');
        },
      );
      this.handleSearch();
    }

    handleSearch = () => {
      if (!this.props.existeCompetenciaInicial) {
        trataMensagensErro(['Não existe competência de pagamento aberta.']);
      } else if (this.state.tipoEntidade && this.props.existeCompetenciaInicial) {
        if (this.state.tipoEntidade === 2 && !this.state.uf && !this.state['destinatario-rpps']) {
          trataMensagensErro(['Escolha uma UF']);
          return;
        }
        if (this.state.tipoEntidade && !this.state['destinatario-rpps']) {
          trataMensagensErro(['Escolha um filtro de destinatário para a consulta']);
          return;
        }
        if (this.state.tipoEntidade && this.state.uf && !this.state['destinatario-rpps']) {
          trataMensagensErro(['Escolha um filtro de destinatário para a consulta']);
          return;
        }
        this.props.handleSearchFilter(this.state);
      } else if (!this.state.tipoEntidade && this.props.existeCompetenciaInicial) {
        this.props.handleSearchFilter(this.state);
      } else {
        trataMensagensErro(['Escolha pelo menos um filtro de Ente federativo para a consulta']);
      }
    }

    listaFiltradaDestinatarios = () => {
      const listaParticipantes = this.props.destinatarios.filter((item) => {
        if (item.tipoRegimeProprio === this.state.tipoEntidade &&
                ((item.uf && this.state.tipoEntidade === 2) ? item.uf === this.state.uf : true)) {
          return item;
        }
        return null;
      });
      return listaParticipantes;
    }

    carregaUfDosMunicipios = () => {
      const listaUf = [];
      this.props.destinatarios.forEach((item) => {
        if (item.uf && !listaUf.find(itemLista => itemLista.value === item.uf)) {
          listaUf.push({
            label: item.uf,
            value: item.uf,
          });
        }
      });
      listaUf.sort((a, b) => {
        if (a.value > b.value) {
          return 1;
        }
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });
      return listaUf;
    }

    montaFiltrosDefault = () => (
      <React.Fragment>
        <div className="row">
          <Grid cols="1 1 1 1">
            <Input
              label="Competência"
              value={this.props.competencia ? `${pad(this.props.competencia.mes, 2)}/${this.props.competencia.ano}` : ''}
              disabled
            />
          </Grid>
          <Grid cols="3 3 3 3">
            <Input
              label="Tipo"
              onChange={e => this.handleChange(e, 'tipoEntidade')}
              placeholder="Selecione a entidade"
              value={this.state.tipoEntidade}
              itemList={tipoEntidade}
              custom
              number
              disabled={!this.props.competencia}
            />
          </Grid>
          {this.state.tipoEntidade === 2 ? (
            <Grid cols="3 3 3 3">
              <Input
                label="UF"
                onChange={e => this.handleChange(e, 'uf')}
                placeholder="Selecione a UF"
                value={this.state.uf}
                itemList={this.carregaUfDosMunicipios()}
                custom
              />
            </Grid>
                ) : ''}
          {this.state.tipoEntidade ? (
            <Grid cols="3 3 3 3">
              <Input
                label="Nome"
                name="destinatario-rpps"
                onChange={e => this.handleChange(e, 'destinatario-rpps')}
                placeholder="Selecione o destinatário"
                value={this.state['destinatario-rpps']}
                itemList={this.listaFiltradaDestinatarios()}
                custom
              />
            </Grid>
                ) : ''}
        </div>
      </React.Fragment>
    )

    montaFiltros = () => {
      if (this.props.tipoConsulta) {
        return this.montaFiltrosDefault();
      }
      return null;
    }

    render() {
      const filtrosPesquisa = this.montaFiltros();
      if (!filtrosPesquisa) {
        return null;
      }
      return (
        <DtpAccordionGroup>
          <DtpAccordionPanel
            headingId="pesquisa"
            panelId="filtro-pesquisa"
            icon="ico-filter"
            title="Filtro de Pesquisa"
          >
            {filtrosPesquisa}
            <div className="row">
              <Button
                className="dtp-primary right"
                title="Pesquisar"
                onClick={() => this.handleSearchButton()}
                hint="Pesquisar de acordo com o filtro aplicado"
                disabled={!this.props.competencia}
              />
            </div>
          </DtpAccordionPanel>
        </DtpAccordionGroup>
      );
    }
}

FiltroEnteGlosa.propTypes = {
  destinatarios: PropTypes.arrayOf().isRequired,
  handleChangeList: PropTypes.func,
  handleSearchFilter: PropTypes.func,
  list: PropTypes.array,
  tipoConsulta: PropTypes.string,
  competencia: PropTypes.string,
}.isRequired;

export default FiltroEnteGlosa;



// WEBPACK FOOTER //
// ./src/pages/glosas/FiltroEnteGlosa.jsx